import { InstructionsCtrl } from './instructions-transfer.controller';

export const InstructionsStepTransfer = {
  controller: InstructionsCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./instructions-transfer.html'),
};
